<template>
  <b-modal
    id="modal-viewer"
    ref="modalViewer"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    :title="$t('viewer.modal.title_scale')"
    centered
    modal-class="modalViewer"
    static
    size="sm"
  >
    <div class="input-group mb-3">
      <input
        id="scale"
        v-model="scale"
        type="number"
        class="form-control text-right scale"
        aria-hidden="true"
      >
      <vt-combo-select
        v-model="unit"
        :options="availableUnits"
      />
    </div>

    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="onCancel"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="onOk"
          >
            <span class="fal fa-save mr-2" />
            {{ $t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
    name: 'ModalMeasureScale',
    data() {
        return {
            onOk: () => {},
            onCancel: () => {},
            unit: null,
            availableUnits: ['m', 'cm', 'mm', 'µm', 'nm'],
            scale: null
        }
    },
    methods: {
        async show(unit, scale, onOk, onCancel) {
            this.unit = unit
            this.scale = scale
            this.onOk = onOk || (() => {})
            this.onCancel = onCancel || (() => {})
            this.$refs.modalViewer.show()
        },
        hide() {
            this.$_cleanComponentData()
            this.$refs.modalViewer.hide()
        },
        hasArea() {
            return this.type === 'Polygon' || this.type === 'Circle' || this.type === 'Square'
        }
    }
}
</script>

<style lang="scss">
    .modalViewer .form-label {
        color: vt-color(white-light, .5);
    }
    .modalViewer input,
    .modalViewer textarea {
        background: vt-color(viewer-main, .4) !important;
        border: none;
        color: vt-color(white-light) !important;
    }
    .modalViewer .color-row .btn {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px !important;
        border: none;
    }
    .modalViewer .color-row .btn:hover {
        box-shadow: 0px 0px 3px 3px #9c9c9c;
    }
    .modalViewer .color-row .btn.active-color {
        box-shadow: 0px 0px 3px 3px #9c9c9c !important;
    }
</style>

<style lang="scss" scoped>
    .offscreen {
        position: absolute;
        left: -9999px;
    }

    .modal-color-btn {
        height: 20px;
        width: 20px;
    }

    .scale{
        font-size: 30px;
    }
</style>
